import { px2cm } from '~src/utils/units';

export const px2mm = (px, dpi) => {
  const cm = px2cm(px, dpi);
  return cm * 10;
};
